export default "__VITE_ASSET__956ef108__"